<template>
  <section class="section">
    <div class="glass-container-main animate__animated animate__fadeIn">
      <div class="level mb-6">
        <div class="level-left">
          <div>
            <h1 class="title is-2 has-text-white mb-2">Análisis Visual</h1>
            <p class="subtitle is-6 has-text-grey-lighter">Representación gráfica de la participación y tendencias</p>
          </div>
        </div>
      </div>

      <!-- Filters -->
      <div class="glass-card p-5 mb-6">
        <div class="columns is-vcentered">
          <div class="column is-narrow">
            <busqueda-en-fecha @seleccionada="onFechas" />
          </div>
          <div class="column is-narrow">
            <b-field label="Filtrar por Estrellas" custom-class="has-text-grey-light">
              <b-select v-model="filtros.calificacion" expanded class="glass-select">
                <option value="">Todas las calificaciones</option>
                <option v-for="n in 5" :key="n" :value="6-n">{{6-n}} estrellas</option>
              </b-select>
            </b-field>
          </div>
        </div>
      </div>

      <!-- Tabs -->
      <div class="tabs is-toggle is-fullwidth glass-tabs mb-6">
        <ul>
          <li :class="{ 'is-active': modo === 'ciudad' }">
            <a @click="cambiarModo('ciudad')">
              <b-icon icon="panorama-variant" class="mr-2" />
              Vista por Ciudad
            </a>
          </li>
          <li :class="{ 'is-active': modo === 'restaurante' }">
            <a @click="cambiarModo('restaurante')">
              <b-icon icon="chart-bar" class="mr-2" />
              Vista por Restaurante
            </a>
          </li>
        </ul>
      </div>

      <!-- Chart Area -->
      <div class="glass-card p-6 chart-wrapper">
        <canvas ref="grafico" height="400"></canvas>
      </div>
    </div>

    <b-loading :is-full-page="true" v-model="cargando" :can-cancel="false" />
  </section>
</template>

<script>
import Chart from 'chart.js'
import HttpService from '../../Servicios/HttpService'
import BusquedaEnFecha from '../Extras/BusquedaEnFecha.vue'

export default {
  name: 'GraficosEstadisticas',
  components: { BusquedaEnFecha },
  data() {
    return {
      datos: [],
      cargando: false,
      modo: 'ciudad',
      filtros: { fechaInicio: '', fechaFin: '', calificacion: '' },
      chart: null
    }
  },
  mounted() {
    this.cargarDatos()
    document.title = "Metropolitan - Gráficos";
  },
  methods: {
    onFechas(f) {
      if (Array.isArray(f)) {
        this.filtros.fechaInicio = f[0] ? f[0].toISOString().split('T')[0] : ''
        this.filtros.fechaFin = f[1] ? f[1].toISOString().split('T')[0] : ''
        this.cargarDatos()
      }
    },
    cambiarModo(m) {
      this.modo = m
      this.cargarDatos()
    },
    cargarDatos() {
      this.cargando = true
      const accion = this.modo === 'ciudad' ? 'por_ciudad' : 'por_restaurante'
      HttpService.registrar('estadisticas.php', { accion, filtros: this.filtros })
        .then(res => {
          this.datos = res || []
          this.graficar()
          this.cargando = false
        }).catch(() => { this.cargando = false; })
    },
    graficar() {
      const labels = this.datos.map(d => d.nombre)
      const valores = this.datos.map(d => d.total)
      if (this.chart) this.chart.destroy()
      const ctx = this.$refs.grafico.getContext('2d')
      
      this.chart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels,
          datasets: [
            {
              label: 'Votos',
              data: valores,
              backgroundColor: 'rgba(59, 130, 246, 0.6)',
              borderColor: '#3b82f6',
              borderWidth: 2,
              borderRadius: 8,
              hoverBackgroundColor: 'rgba(59, 130, 246, 0.8)'
            }
          ]
        },
        options: { 
          responsive: true, 
          maintainAspectRatio: false,
          legend: {
            display: true,
            labels: { fontColor: '#fff', fontFamily: 'Poppins' }
          },
          scales: {
            yAxes: [{
              ticks: { beginAtZero: true, fontColor: 'rgba(255,255,255,0.7)', fontFamily: 'Poppins' },
              gridLines: { color: 'rgba(255,255,255,0.1)' }
            }],
            xAxes: [{
              ticks: { fontColor: 'rgba(255,255,255,0.7)', fontFamily: 'Poppins' },
              gridLines: { display: false }
            }]
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.glass-container-main {
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(15px);
  border-radius: 24px;
  padding: 40px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  min-height: 80vh;
}

.glass-card {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.glass-tabs /deep/ a {
  background: rgba(255, 255, 255, 0.05) !important;
  border-color: rgba(255, 255, 255, 0.1) !important;
  color: #94a3b8 !important;
}

.glass-tabs /deep/ .is-active a {
  background: #3b82f6 !important;
  border-color: #3b82f6 !important;
  color: white !important;
}

.chart-wrapper {
  height: 450px;
}

.glass-select /deep/ select {
  background-color: rgba(30, 41, 59, 0.8) !important;
  color: white !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
}
</style>
